/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon20Solid = forwardRef('ArrowDCornerUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.634 1.116a1.25 1.25 0 0 0-1.768 1.768l3.366 3.366H6A3.75 3.75 0 0 0 2.25 10v7.5a1.25 1.25 0 1 0 2.5 0V10c0-.69.56-1.25 1.25-1.25h9.232l-3.366 3.366a1.25 1.25 0 0 0 1.768 1.768l4.44-4.44a2.75 2.75 0 0 0 0-3.889l-4.44-4.439Z" })));
});
